// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3N_Ka","header":"MergedInvoice_header__mDHAG"};